import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

export const fetchBreakUpSummary = createAsyncThunk(
  "/fetchBreakUpSummary",
  async ( plan_id , { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(`/fetch-break-foc-paid/client-appsells/${plan_id}`, {
        
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch break up summary");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching break up summary"
      );
    }
  }
);

const fetchBreakUpSummarySlice = createSlice({
  name: "fetchBreakUpSummary",
  initialState: { 
    data :{} ,
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBreakUpSummary.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchBreakUpSummary.fulfilled, (state, action) => {
        console.log("payload : " + JSON.stringify(action.payload)) ;
        state.status = "succeeded";
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchBreakUpSummary.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default fetchBreakUpSummarySlice.reducer;
